import styles from "./TimelineLines.module.scss";

interface TimelineLinesProps {
  size: number;
};

const TimelineLines: React.FC<TimelineLinesProps> = ({
  size,
}) => (
  <div className={styles.lines} style={{ gridTemplateColumns: `repeat(${size - 1}, 1fr)` }}>
    {Array.from({ length: size - 1 }, (_, i) => i).map((i) => (
      <div key={i} className={`${styles.cell} ${i % 2 === 0 ? styles.solid : styles.dashed}`} />
    ))}
  </div>
)

export default TimelineLines;